import { errorService } from './services/error'
import { ApiService } from './services/api'
import { AuthService } from './services/auth'
import { MainService } from './services/main'
import { AutoService } from './services/auto'
import { ConnService } from './services/conn'
import { CommService } from './services/comm'
import { EventsService } from './services/events'
import { FieldsService } from './services/fields'
import { PartiesService } from './services/parties'
import { CatalogService } from './services/catalog'
import { SpaceContextService } from './services/space-context'
import { registerPlatformSurface } from './platform/ui'
import router, { setApiService } from './router'
import { createApp } from 'vue'
import App from './App.vue'
import './index.css'

;(window as any).__errorService = errorService

window.onerror = (message, source, lineno, colno, error) => {
	errorService.showError(error || message)
}

window.addEventListener('unhandledrejection', (event) => {
	console.error('Unhandled promise rejection:', event.reason)
	errorService.showError(event.reason)
})

async function initApp()
{
	try {
		const apiService = new ApiService()
		await apiService.fetchConfig()

		if (apiService.getConfig().cp_domain !== window.location.hostname)
			throw new Error([
				'Недопустимый домен.',
				`Ожидаемый домен: ${apiService.getConfig().cp_domain}`,
				`Текущий домен: ${window.location.hostname}`
			].join('\n'))

		const authService = new AuthService(apiService)
		const mainService = new MainService(apiService)
		const autoService = new AutoService(apiService)
		const connService = new ConnService(apiService)
		const commService = new CommService(apiService)
		const eventsService = new EventsService(apiService)
		const fieldsService = new FieldsService(apiService)
		const partiesService = new PartiesService(apiService)
		const catalogService = new CatalogService(apiService)
		const spaceContextService = new SpaceContextService(mainService)

		const app = createApp(App)

		app.provide('errorService', errorService)
		app.provide('apiService', apiService)
		app.provide('authService', authService)
		app.provide('mainService', mainService)
		app.provide('autoService', autoService)
		app.provide('connService', connService)
		app.provide('commService', commService)
		app.provide('eventsService', eventsService)
		app.provide('fieldsService', fieldsService)
		app.provide('partiesService', partiesService)
		app.provide('catalogService', catalogService)
		app.provide('spaceContextService', spaceContextService)

		registerPlatformSurface({
			surfaceKey: 'platform.event_reaction.editor',
			ownerKind: 'platform',
			ownerKey: 'event_reactions',
			loadComponent: () => import('@/views/events/EventReactionSurface.vue'),
			defaultTitle: 'Реакция на событие',
			defaultPresentation: 'standard',
		})

		setApiService(apiService)
		app.use(router)

		app.config.errorHandler = (err, instance, info) => {
			console.error('Vue error:', err, 'Info:', info)
			errorService.showError(err)
		}

		app.mount('#app')
	} catch (error) {
		console.error('Критическая ошибка инициализации:', error)
		errorService.showError(error)

		const appElement = document.getElementById('app')
		if (!appElement) {
			alert([
				'Критическая ошибка инициализации.',
				error instanceof Error ? error.message : 'Неизвестная ошибка',
				'',
				'Попробуйте перезагрузить страницу.'
			].join('\n'))
			return
		}

		setTimeout(() => {
			if (appElement.querySelector('.error-modal'))
				return

			appElement.innerHTML = `
<div class="critical-error">
	<h1>Ошибка инициализации приложения</h1>
	<p>${error instanceof Error ? error.message : 'Неизвестная ошибка'}</p>
	<div class="error-actions">
		<button onclick="location.reload()">Попробовать снова</button>
		<button onclick="location.href='mailto:support@grwth.ru?subject=Ошибка%20в%20приложении&body=${encodeURIComponent(window.location.href)}'">Сообщить в поддержку</button>
	</div>
</div>`
		}, 1000)
	}
}

initApp().then(() => {
	console.log('Приложение инициализировано')
}, (error) => {
	console.error('Ошибка инициализации приложения:', error)
})

